import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Tree, Button, Row, Col } from 'antd';
import { DownOutlined } from '@ant-design/icons'
import { fetchCategoryTree } from '../actions/CategoryCreators';

const { TreeNode } = Tree;

const convertCategoryToTreeNodes = (treeNode: any, titlePrefix: string) => {
    if (!treeNode) {
        return null;
    }
    let title = treeNode.category.id + '-' + titlePrefix + treeNode.category.displayTerm + '(' + treeNode.category.term + ')';
    let key = treeNode.category.id;

    return (
        <TreeNode title={title} key={key}>
            {
                treeNode.children 
                    && treeNode.children.length > 0 
                    && treeNode.children.map((children, index) => {
                        return convertCategoryToTreeNodes(children, titlePrefix + treeNode.category.displayTerm + '-')
                    })
            }
        </TreeNode>
    );
}

const convertCategoryToTree = (categories) => {
    if (!categories) {
        return null;
    }

    if (categories.categoryTree && categories.categoryTree.children && categories.categoryTree.children.length > 0) {
        return (
            <TreeNode title="分类树" key='root'>
                {
                    categories.categoryTree.children.map((children) => {
                        return convertCategoryToTreeNodes(children, '')
                    })
                }
            </TreeNode>
        )
    }
    return null;
}

const CategoryTreeContainer = (props: any) => {
    const {
        categories,
        fetchCategoryTree
    } = props
    const [expandedKeys, setExpandedKeys] = useState(getInitExpandedKeys(categories));
    const [allKeys, setAllKeys]: any = useState([]);

    useEffect(() => {
        fetchCategoryTree();
    }, []);

    useEffect(() => {
        setExpandedKeys(getInitExpandedKeys(categories));
        setAllKeys(getAllKeys([categories?.categoryTree] || []));
    }, [categories])

    function handleExpandChange(expandedKeys) {
        setExpandedKeys(expandedKeys);
    }

    function getInitExpandedKeys(categories) {
        return categories
            && categories.categoryTree
            && categories.categoryTree.children
            ? ['root'].concat(categories.categoryTree.children.map(c => c.category.id))
            : ['root'];
    }

    function getAllKeys(data: any) {
        let keys: Array<any> = [];
        data?.forEach((item: any) => {
            if(item && item.children) {
                keys = keys.concat([item?.category?.id || 'root'].concat(getAllKeys(item?.children)));
            }
        });
        return keys;
    }

    return (
        <div style={{
            minHeight: '400px',
            padding: '30px',
            background: '#fff',
        }} className='container-fluid pt-3'>
            <Row justify="end">
                <Col span={4}>
                    <Button type="primary" onClick={() => setExpandedKeys(allKeys)}>expand all</Button>
                </Col>
                <Col span={4}>
                    <Button type="primary" onClick={() => setExpandedKeys([])}>collapse all</Button>
                </Col>
            </Row>
            {
                categories.categoryTree 
                && categories.categoryTree.children 
                && categories.categoryTree.children.length > 0
                && (
                    <Tree
                        showLine
                        expandedKeys={expandedKeys}
                        onExpand={handleExpandChange}
                        switcherIcon={<DownOutlined />}>
                        {
                            convertCategoryToTree(categories)
                        }
                    </Tree>
                )
            }
        </div>
    )
}

function mapDispatchToProps(dispatch: any) {
    return bindActionCreators({ fetchCategoryTree }, dispatch);
}

function mapStateToProps(state: any) {
    return {
        categories: state.categories,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CategoryTreeContainer);
